import React from 'react'

const InstructionsTextSolicitudViolencia = () => {
  return (
    <div className='flex flex-col items-center stify-items-center'> 
      <h2 className='card-content text-3xl'>Bienvenid@</h2>
      <p className='text-lg mt-6 text-lg'>Para iniciar una demanda ingresa los datos que se piden a continuación, para poder enviar la demanda solo necesitas un número celular o correo electrónico.</p>
    </div>
  )
}

export { InstructionsTextSolicitudViolencia }